module.exports = __webpack_public_path__ + "static/fonts/Oswald-Bold.92837a2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-Bold.ttf
// module id = FeEe
// module chunks = 1